import { PropsWithChildren } from "react";
import { PublicContentShareStatusResponse, ShareStatus } from "@authory-packages/core";
import { V3ModalPublicPasswordContent } from "../../components/V3ModalPublicPasswordContent";
import { usePublicContentItemAccessKeyContext } from "../../context/publicContentItemAccessKeyContext";
import { getPublicContentItemClient } from "../../utils/query-utils/getContentItem";
import { NoIndexHead } from "../../components/NoIndexHead";
import { isGatedShareStatus } from "../../utils/isGatedShareStatus";

interface ContentItemAccessGateProps {
    contentItemShareStatus: PublicContentShareStatusResponse;
    isStandaloneContentItemView: boolean;
}

export const ContentItemAccessGate = ({
    children,
    contentItemShareStatus,
    isStandaloneContentItemView
}: PropsWithChildren<ContentItemAccessGateProps>) => {
    const { setContentItemAccessKey } = usePublicContentItemAccessKeyContext();
    const { item } = getPublicContentItemClient(isStandaloneContentItemView, false, contentItemShareStatus);

    // A gated resource is not server rendered, so the robots directive has to come from the gate itself
    const isGated =
        isGatedShareStatus(contentItemShareStatus?.shareStatus, ShareStatus.SecureLinkOptionalPasswordProtected) ||
        !!contentItemShareStatus?.isPasswordProtected;
    const noIndex = isGated ? <NoIndexHead /> : null;

    if (!item)
        return (
            <>
                {noIndex}
                {children}
            </>
        );

    const { isSuccess, isFetching } = item;

    if (contentItemShareStatus?.isPasswordProtected && !isSuccess) {
        return (
            <>
                {noIndex}
                <V3ModalPublicPasswordContent
                    onSubmit={(data) => {
                        setContentItemAccessKey(data.password);
                    }}
                    isFetching={isFetching}
                />
            </>
        );
    }

    return (
        <>
            {noIndex}
            {children}
        </>
    );
};
